/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The method used to install the cloud role
*/
export enum RoleInstallationMethod {
  INSTALLATION_METHOD_UNKNOWN = 'UNKNOWN_METHOD',
  INSTALLATION_METHOD_CLOUDFORMATION = 'CLOUDFORMATION',
  INSTALLATION_METHOD_TERRAFORM = 'TERRAFORM',
  INSTALLATION_METHOD_BASH_SCRIPT = 'BASH_SCRIPT'
}
